import ServerBaseError from './ServerBaseError';

export default class RequestTimeoutError extends ServerBaseError {
  constructor(url: string, timeout: number, showErrorPage = false) {
    super(`Request to ${url} timeout of ${timeout}ms exceeded`, showErrorPage);
  }
}
